module.exports = __webpack_public_path__ + "img/compact.33686488.png";